"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizeURL = void 0;
// https://github.com/facebook/react/blob/e0d9b289998c66d2e4fb75582b9e107054e4e0a4/packages/react-dom/src/shared/sanitizeURL.js#L23
const IS_JAVASCRIPT_PROTOCOL = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i;
const sanitizeURL = (url) => {
    if (url && IS_JAVASCRIPT_PROTOCOL.test(url)) {
        console.error('Javascript in URL blocked as a security precaution.');
        return '';
    }
    return url;
};
exports.sanitizeURL = sanitizeURL;
//# sourceMappingURL=sanitizeURL.js.map